import { createFormula } from './base';
import { FormulaRegistry } from './registry';

// Creates a standard formula for calculating monthly payments with documentation fee
// Parameters:
// - price: Total price of the item
// - downPayment: Initial payment amount
// - aprLowerBound: Lower bound of Annual Percentage Rate
// - aprUpperBound: Upper bound of Annual Percentage Rate
// - term: Length of loan in months
// - docFee: Documentation fee amount

const createStandardFormula = () => {
  return createFormula(
    'standard',
    'Standard formula including documentation fee',
    ({ price, downPayment, aprLowerBound, aprUpperBound, term, docFee }) => {
      // Calculates monthly payment amount based on loan parameters
      // Returns minimum $100 payment if calculated amount is less
      const calculateMonthlyPayment = (
        price,
        downPayment,
        apr,
        term,
        docFee
      ) => {
        if (apr === 0) return 100;

        const amount = price + docFee - downPayment;
        const monthlyInterestRate = apr / 100 / 12;

        const monthlyRate = Math.round(
          (amount * monthlyInterestRate) /
            (1 - Math.pow(1 + monthlyInterestRate, -term))
        );

        if (monthlyRate < 100) return 100;
        return monthlyRate;
      };

      return {
        from: calculateMonthlyPayment(
          price,
          downPayment,
          aprLowerBound,
          term,
          docFee
        ),
        to: calculateMonthlyPayment(
          price,
          downPayment,
          aprUpperBound,
          term,
          docFee
        ),
      };
    }
  );
};

const standardFormula = createStandardFormula();
FormulaRegistry.register('standard', standardFormula, true);
